import { BlockUiService } from '../services/blockui.service';
import { CaseService } from '../services/case.service';
import { CasesComponent } from '../cases/cases.component';
import { RowContentDelaComponent } from './row-content-dela/row-content-dela.component';
import { DatePipe } from '@angular/common';
import { Component, OnInit, Host, ViewContainerRef, ViewChild, HostListener } from '@angular/core';
import { ReportService } from '../services/report.service';
import { StorageService } from '../services/storage.service';
import * as FileSaver from 'file-saver';

@Component({
	selector: 'app-show-nasrocheni-dela',
	templateUrl: './show-nasrocheni-dela.component.html',
	styleUrls: ['./show-nasrocheni-dela.component.scss']
})
export class ShowNasrocheniDelaComponent implements OnInit {

	@ViewChild('editCase') editCase;

	[x: string]: any;

	private currentUserColor = '#FFFFFF';

	constructor(private blockUi: BlockUiService,
		private reportService: ReportService,
		private vcRef: ViewContainerRef,
		private caseService: CaseService,
		private datePipe: DatePipe,
		private storageService: StorageService) {
	}

	public rowComponent = RowContentDelaComponent;
	public colsCases = [
		{ title: 'Дата', name: 'dataNasrochen' },
		{ title: 'Час', name: 'timeNasrochen' },
		{ title: 'Ищци', name: 'claimantListShort' },
		{ title: 'Ответници', name: 'defendantListShort' },
		{ title: 'Гражданско дело номер', name: 'case_number' },
		{ title: 'Съд', name: 'court' },
		{ title: 'Отговорник', name: 'lawyer' },
		{ title: 'Бележка', name: 'noteShort' }
	];
	caseList: Array<any>;
	selectedCase: any;
	isExtended: boolean;
	ngOnInit() {
		this.caseList = new Array<any>();
		this.isExtended = false;
		this.currentUserColor = this.storageService.getLoginResponse().color || '#FFFFFF';
		this.loadNasrocheniDelaList();
	}

	loadNasrocheniDelaList() {
		this.blockUi.start(this.vcRef);
		this.caseList = new Array<any>();
		this.caseService.getNasrocheniDelaByUser(this.isExtended).subscribe(lst => {
			this.caseList = lst;
			for (let i = 0; i < this.caseList.length; i++) {
				let noteShort = '';
				let claimantShort = '';
				let defendantShort = '';
				this.caseList[i].dataNasrochen = this.datePipe.transform(this.caseList[i].dataNasrochen, 'dd.MM.yyyy');
				if (this.caseList[i].note != null) {
					noteShort = this.caseList[i].note.substring(0, 10) + '...';
				}
				if (this.caseList[i].claimantList != null) {
					claimantShort = this.caseList[i].claimantList.substring(0, 10) + '...';
				}
				if (this.caseList[i].defendantList != null) {
					defendantShort = this.caseList[i].defendantList.substring(0, 10) + '...';
				}
				this.caseList[i].noteShort = noteShort;
				this.caseList[i].claimantListShort = claimantShort;
				this.caseList[i].defendantListShort = defendantShort;
				this.caseList[i].color = this.caseList[i].lawyerColor || this.currentUserColor;
			}
			this.blockUi.stop();
		},
			error => {
				this.blockUi.stop();
			});
	}

	public extractNasrocheniExcel() {
		this.blockUi.start(this.vcRef);
		this.reportService.executeNasrocheniXLSReport(this.isExtended).subscribe({
			next: response => {
				this.blockUi.stop();

				const contentDisposition = response.headers.get('Content-Disposition');
				let filename = 'report.xlsx';

				// Извличане на името от хедъра
				if (contentDisposition) {
					const match = contentDisposition.match(/filename="?([^"]+)"?/);
					if (match && match[1]) {
						filename = match[1];
					}
				}

				const blob = new Blob([response.body], {
					type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
				});
				FileSaver.saveAs(blob, filename);
			},
			error: err => {
				console.log(err);
				this.blockUi.stop();
			}
		});
	}

	editCaseFromDelo(row) {
		// to do here 
	}

	public expanderClicked(event: any) {
		this.selectedCase = event;
	}

	@HostListener('document:keydown', ['$event'])
	handleKeyboardEvent(event: KeyboardEvent) {

		// 👉 Ctrl + Enter -> Търси
		if (event.ctrlKey && event.key === 'Enter') {
			event.preventDefault();
			this.loadNasrocheniDelaList();        // твоя метод за търсене
		}
	}

}
